import { gql } from '@apollo/client';

//Update this!
export const GET_TD_SERVER_URL = gql`
  query GET_TD_SERVER_URL($originatorId: ID!){
    getTdServerUrl(originatorId: $originatorId) {
     url
     args
  }
}
`;